import { Router, UrlTree } from '@angular/router';

import { ApiAuthenticationProviderEnum } from './provider.enum';

export interface AuthenticationConfig {
  apiKey: string;
  authDomain: string;
  authProviderUrl?: string;
  storageKey: string;
  authAppName?: string;
  createUrlTree?: (router: Router) => UrlTree | boolean;
  limitProvidersTo?: ApiAuthenticationProviderEnum[];
}
